import isFunction from 'utils/validation/isFunction'

let changeEvent
if (isFunction(Event)) {
  changeEvent = new Event('change', { bubbles: true })
} else {
  changeEvent = document.createEvent('Event')
  changeEvent.initEvent('change', true, false)
}

export default changeEvent
